// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2J4JU","left":"StickyBox_left__39vbn","right":"StickyBox_right__hljCx"};